import { useMemo, useState } from "react";
import { defaultPresentation, STEP_TITLES, STEPS } from "./utils";
import PresentationWizardDialog from "./WizardDialog";
import _ from "lodash";
import PresentationPicker from "../components/PresentationPicker";
import QuantityPicker from "../components/QuantityPicker";

const BrandBoxPresentationPicker = ({ medicine, onSelect }) => {
  const presentations = useMemo(() => 
    _.map(medicine.presentaciones, presentation => _.assign({}, presentation, { displayName: `${presentation.name}` }))
  , [medicine]);

  return <PresentationPicker presentations={presentations} onSelect={onSelect} />;
};

const BrandSelectionStrategy = ({ medicine, onComplete, onClose }) => {
  const [presentation, setPresentation] = useState(defaultPresentation);

  const getCurrentStep = () => 
    !presentation.name ? STEPS.PRESENTATION : STEPS.QUANTITY;

  const stepComponents = {
    [STEPS.QUANTITY]: (
      <QuantityPicker
        onSelect={quantity => {
          onComplete(quantity, presentation);
        }} 
      />
    ),
    [STEPS.PRESENTATION]: (
      <BrandBoxPresentationPicker 
        medicine={medicine}
        onSelect={setPresentation}
      />
    )
  };

  const currentStep = getCurrentStep();

  return (
    <PresentationWizardDialog
      open
      onClose={onClose}
      title={STEP_TITLES[currentStep]}
    >
      {stepComponents[currentStep]}
    </PresentationWizardDialog>
  );
};

export default BrandSelectionStrategy;